import { AboutGurudev } from "../components/home/AboutGurudev";
import { EventsInsights } from "../components/home/EventsInsights";
import { BooksCollection, MediaGallery } from "../components/home/Galleries";
import { GuruvaniOrg } from "../components/home/GuruvaniOrg";
import { Hero } from "../components/home/Hero";
import { Supporters } from "../components/home/Supporters";

export default function Home() {
  return (
    <>
      <Hero />
      <MediaGallery />
      <AboutGurudev />
      <GuruvaniOrg />
      <Supporters />
      <EventsInsights />
      <BooksCollection />
    </>
  );
}
